export default __webpack_public_path__ + "static/media/RIDE4overlay.f276cc68.jpg";